import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import * as Icon from 'react-feather';
import scrollToComponent from 'react-scroll-to-component';
import Particles from 'react-particles-js';

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            menu_item: "/",
            video: true
        };
        this.headerRef = React.createRef();
    };

    componentWillMount() {
        this._setView();
        if(window.innerWidth < 1000){
            this.setState({video: false});
        }
    }

    _goLink(option){
        window.open(option, '_blank');
    }

    _goInternal(option){
        window.open(option, '_self');
    }

    _scrollDown(){
        scrollToComponent(this.headerRef.current, {align: 'top', offset: 0, duration: 500});
    }

    _setView(){
        try {
            this.setState({menu_item: this.props.view});
        }catch (e) {}
    }

    _setMenuItem(option) {
        if(this.state.menu_item === "/contact" && option === "/contact"){
            this._scrollDown();
            this.setState({menu: false});
        }else{
            this.setState({menu_item: option}, () => {
                try {
                    this.props.props.history.push(option);
                    this.setState({menu: false});
                }catch (e) {}
            });
        }
    }

    _renderTitle(){
        if(this.state.menu_item === "/"){
            return(
                <div className={Styles.headerImageContainerInner}>
                    <div className={Styles.headerImageContainerInnerItem}>
                        SWEDISH
                    </div>
                    <div className={Styles.headerImageContainerInnerItem}>
                        TECH
                    </div>
                    <div className={Styles.headerImageContainerInnerItem}>
                        MAFIA
                    </div>
                    <div className={Styles.headerImageContainerInnerSubtitle}>
                        <span className={Styles.headerImageContainerInnerSubtitleWhite}>We are a tech hub spread across Stockholm, Dubai and Barcelona. We team up with entrepreneurs, investors and companies to invent, build and invest in digital startups.</span>
                    </div>
                </div>
            )
        }else if(this.state.menu_item === "/lab"){
            return(
                <div className={Styles.headerImageContainerInner}>
                    <div className={Styles.headerImageContainerInnerItem}>
                        CHECK
                    </div>
                    <div className={Styles.headerImageContainerInnerItem}>
                        OUR
                    </div>
                    <div className={Styles.headerImageContainerInnerItem}>
                        LAB
                    </div>
                    <div className={Styles.headerImageContainerInnerSubtitle}>
                        <span className={Styles.headerImageContainerInnerSubtitleWhite}>We're using the most cutting-edge technology to innovate innovation. Here's how we're embracing innovation around the world, one digital tool at a time.</span>
                    </div>
                </div>
            )
        } else if(this.state.menu_item === "/partners"){
            return(
                <div className={Styles.headerImageContainerInner}>
                    <div className={Styles.headerImageContainerInnerItem}>
                        MEET
                    </div>
                    <div className={Styles.headerImageContainerInnerItem}>
                        OUR
                    </div>
                    <div className={Styles.headerImageContainerInnerItem}>
                        PARTNERS
                    </div>
                    <div className={Styles.headerImageContainerInnerSubtitle}>
                        <span className={Styles.headerImageContainerInnerSubtitleWhite}>
                             Together with our partners, we aim to strengthen entrepreneurial ecosystems around the world and support impact-driven entrepreneurs on their journey from idea to impact at scale.
                        </span>
                    </div>
                </div>
            )
        }else if(this.state.menu_item === "/about"){
            return(
                <div className={Styles.headerImageContainerInner}>
                    <div className={Styles.headerImageContainerInnerItem}>
                        TECH
                    </div>
                    <div className={Styles.headerImageContainerInnerItem}>
                        WONDERS
                    </div>
                    <div className={Styles.headerImageContainerInnerItem}>
                        INC
                    </div>
                    <div className={Styles.headerImageContainerInnerSubtitle}>
                        <span className={Styles.headerImageContainerInnerSubtitleWhite}>Sweden’s renowned history of tech wonders continues to amuse. Unicorns like Skype, Spotify, Minecraft, Truecaller and Klarna have inspired tech start-ups around the world…</span>
                    </div>
                </div>
            )
        }else if(this.state.menu_item === "/contact"){
            return(
                <div className={Styles.headerImageContainerInner}>
                    <div className={Styles.headerImageContainerInnerItem}>
                        LETS
                    </div>
                    <div className={Styles.headerImageContainerInnerItem}>
                        MAKE IT
                    </div>
                    <div className={Styles.headerImageContainerInnerItem}>
                        HAPPEN!
                    </div>
                    <div className={Styles.headerImageContainerInnerSubtitle}>
                        <span className={Styles.headerImageContainerInnerSubtitleWhite}>We are one of the most skilled development teams in the world. Always delivering your projects with attention to detail and on compressed timelines.</span>
                    </div>
                </div>
            )
        }else if(this.state.menu_item === "/campaign"){
            return(
                <div className={Styles.headerImageContainerInner}>
                    <div className={Styles.headerImageContainerInnerItem}>
                        <span className={Styles.headerImageContainerInnerItemGreen}>NEED</span>
                    </div>
                    <div className={Styles.headerImageContainerInnerItem}>
                        APP/WEB?
                    </div>
                    <div className={Styles.headerImageContainerInnerSubtitle}>
                        <span className={Styles.headerImageContainerInnerSubtitleWhite}>We are one of the most skilled development teams in the world, now available in Dubai. Always delivering your projects with attention to detail and on compressed timelines. Benchmark us, get a free on spot assessment. Hit the whatsapp button now...</span>
                    </div>
                    <div onClick={() => this._goInternal("whatsapp://send?text=Hey Swedish Tech Mafia...&phone=+971543429986")} className={Styles.headerImageContainerInnerButton}>
                        <div>
                            <img className={Styles.headerImageContainerInnerButtonIcon} src={require("../../assets/images/STM_social_whatsapp_Black.png")}/>
                            <div className={Styles.headerImageContainerInnerButtonText}>Whatsapp us!</div>
                        </div>
                    </div>
                </div>
            )
        }else{
            return(
                <div className={Styles.headerImageContainerInner}>
                    <div className={Styles.headerImageContainerInnerItem}>
                        404
                    </div>
                    <div className={Styles.headerImageContainerInnerSubtitle}>
                        <span className={Styles.headerImageContainerInnerSubtitleWhite}>We can't seem to find the page you are looking for. </span>
                    </div>
                </div>
            )
        }
    }

    render() {
        return (
            <div className={
                cx(Styles.header,
                    {
                        [Styles.headerBackgroundHome]: this.state.menu_item === "/",
                        [Styles.headerBackgroundOther]: this.state.menu_item !== "/",
                    })
            }>
                {
                    this.state.video && this.state.menu_item === "/" &&
                    <video autoPlay muted loop className={Styles.headerVideo}>
                        <source src={require("../../assets/images/bg-movie.mp4")} type="video/mp4"/>
                    </video>
                }
                <div className={Styles.headerMobileMenu}>
                    <div className={cx(Styles.headerMobileMenuInner,
                        {
                            [Styles.headerMobileMenuInnerOpen]: this.state.menu
                        })}>
                        <div onClick={() => this._setMenuItem("/")} className={Styles.headerMobileMenuInnerItem}>
                            Home
                        </div>
                        <div onClick={() => this._setMenuItem("/lab")} className={Styles.headerMobileMenuInnerItem}>
                            Lab
                        </div>
                        <div onClick={() => this._setMenuItem("/partners")} className={Styles.headerMobileMenuInnerItem}>
                            Partners
                        </div>
                        <div onClick={() => this._setMenuItem("/about")} className={Styles.headerMobileMenuInnerItem}>
                            About us
                        </div>
                        <div onClick={() => this._setMenuItem("/contact")} className={Styles.headerMobileMenuInnerItem}>
                            Contact
                        </div>
                    </div>
                </div>
                <div className={Styles.headerLogo}>
                    <img onClick={() => this._setMenuItem("/")} src={require("../../assets/images/logo.png")} className={Styles.headerLogoIcon}/>
                </div>
                <div className={Styles.headerImageContainer}>
                    {
                        this._renderTitle()
                    }
                </div>
                <div className={Styles.headerTopMenu}>
                    <div onClick={() => this._setMenuItem("/")} className={
                        cx(Styles.headerTopMenuItem,
                            {
                                [Styles.headerTopMenuItemActive]: this.state.menu_item === "/",
                            })
                    }>
                        Welcome
                    </div>
                    <div onClick={() => this._setMenuItem("/lab")} className={
                        cx(Styles.headerTopMenuItem,
                            {
                                [Styles.headerTopMenuItemActive]: this.state.menu_item === "/lab",
                            })
                    }>
                        Lab
                    </div>
                    <div onClick={() => this._setMenuItem("/partners")} className={
                        cx(Styles.headerTopMenuItem,
                            {
                                [Styles.headerTopMenuItemActive]: this.state.menu_item === "/partners",
                            })
                    }>
                        Partners
                    </div>
                    <div onClick={() => this._setMenuItem("/about")} className={
                        cx(Styles.headerTopMenuItem,
                            {
                                [Styles.headerTopMenuItemActive]: this.state.menu_item === "/about",
                            })
                    }>
                        About us
                    </div>
                    <div onClick={() => this._setMenuItem("/contact")} className={
                        cx(Styles.headerTopMenuItem,
                            {
                                [Styles.headerTopMenuItemActive]: this.state.menu_item === "/contact",
                            })
                    }>
                        Contact
                    </div>
                </div>
                {
                    false &&
                    <div onClick={() => this._scrollDown()} className={Styles.headerSideNav}>
                        <div className={Styles.headerSideNavRight}>
                            <Icon.ArrowDown color={"#000000"}/>
                        </div>
                    </div>
                }
                {
                    false &&
                  <div onClick={() => this._setMenuItem("/contact")} className={Styles.headerContactButton}>
                      Contact us!
                  </div>
                }
                {
                    false &&
                    <div className={Styles.headerFollowUsContainer}>
                        <div className={Styles.headerFollowUsContainerTitle}>
                            Follow us
                        </div>
                        <div className={Styles.headerFollowUsContainerDivider}>
                            -
                        </div>
                        <div onClick={() => this._goLink("https://www.facebook.com/Swedish-Tech-Mafia-485893315247082")} className={Styles.headerFollowUsContainerLink}>
                            Facebook
                        </div>
                        <div onClick={() => this._goLink("https://www.linkedin.com/in/swedishtechmafia")} className={Styles.headerFollowUsContainerLink}>
                            LinkedIn
                        </div>
                        <div onClick={() => this._goLink("https://www.instagram.com/swedishtechmafia")} className={Styles.headerFollowUsContainerLink}>
                            Instagram
                        </div>
                        <div onClick={() => this._goLink("https://www.twitter.com/swetechmafia")} className={Styles.headerFollowUsContainerLink}>
                            Twitter
                        </div>
                    </div>
                }
                <div style={{position: "absolute", left: "0", right: "0", bottom: "0"}} ref={this.headerRef}/>
            </div>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/header/component.js